export enum TableStatuses {
  AVAILABLE,
  TWO_HOURS,
  ONE_HOUR_HALF,
  ONE_HOUR,
  OCCUPIED,
}
